import axiosInstance from "../config/config";

// These used to call the GoHighLevel v1 API directly with a location API key.
// v1 is deprecated, so the calls now go through the backend, which uses the
// GHL v2 API. The backend returns `{ contact: { ...contact, customField, tags } }`,
// preserving the shape the modals/hooks already read.

// IAIH directory stays on GoHighLevel (only the Nirva/clinic side is leaving GHL).
export const fetchMemberDirectoryStatus = async (id) => {
  try {
    const response = await axiosInstance.get(
      `gohighlevel/contacts/${id}?account=iaih`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching iaih user data:", error);
    return null;
  }
};
